import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../api/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/settings/school-fees/default/`;

export const fetchSchoolFees = createAsyncThunk(
    'schoolFees/fetch',
    async (_, thunkAPI) => {
      try {
        const response = await axios.get(BASE_URL);
        return response.data;
      } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Fetch failed');
      }
    }
  );

  export const fetchCurrentYearSchoolFees = createAsyncThunk(
  'schoolFees/fetchCurrentYear',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/settings/school-fees/current-year-total/`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Fetch failed');
    }
  }
);


export const updateSchoolFeesByStudent = createAsyncThunk(
  'schoolFees/updateByStudent',
  async ({ studentId, feeInputs, school_year }, thunkAPI) => {
    try {
      const payload = {
        student: studentId,
        school_fee: feeInputs.annualFee,
        books_fee: feeInputs.booksFee,
        trans_fee: feeInputs.transportFee,
        clothes_fee: feeInputs.uniformFee,
        clothes_fee_paid: feeInputs.clothesFeePaid,
        school_year: school_year,
      };

      console.log('🚀 Sending payload to update-by-student:', payload);

      // Use the custom endpoint that handles both create and update
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/settings/school-fees/update-by-student/`,
        payload
      );

      console.log('✅ Response from update-by-student:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error in updateSchoolFeesByStudent:', error.response?.data);
      return thunkAPI.rejectWithValue(error.response?.data || 'Update failed');
    }
  }
);


  
  export const updateSchoolFees = createAsyncThunk(
    'schoolFees/update',
    async (data, thunkAPI) => {
      try {
        const response = await axios.put(BASE_URL, data);
        return response.data;
      } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Update failed');
      }
    }
  );
  
  const schoolFeesSlice = createSlice({
    name: 'schoolFees',
    initialState: {
      data: null,
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchSchoolFees.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchSchoolFees.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
        })
        .addCase(fetchSchoolFees.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
        .addCase(updateSchoolFeesByStudent.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchCurrentYearSchoolFees.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(fetchCurrentYearSchoolFees.fulfilled, (state, action) => {
  state.loading = false;
  state.data = action.payload;
})
.addCase(fetchCurrentYearSchoolFees.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})
        .addCase(updateSchoolFeesByStudent.fulfilled, (state, action) => {
          state.loading = false;
          // optionally update state.data if needed
        })
        .addCase(updateSchoolFeesByStudent.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })        
        .addCase(updateSchoolFees.fulfilled, (state, action) => {
          state.data = action.payload;
        });
    }
  });
  
  export default schoolFeesSlice.reducer;